<template>
  <div :class="$options.name">
    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.name"
            :rules="rules.name"
            label="Название WMS"
          />

          <v-jsoneditor
            v-if="advancedMode"
            v-model="json"
            height="400px"
            class="mb-4"
          />

          <v-text-field
            v-else
            v-model="form.url"
            label="Ссылка на тайлы"
          />

          <v-switch
            v-model="form.published"
            :label="publishedText"
            color="success"
            hide-details
          />

          <div class="d-flex justify-end align-center">
            <a href="#" @click="advancedMode = !advancedMode">
              {{ !advancedMode ? 'Расширенные настройки' : 'Упрощенный вариант' }}
            </a>
            <v-btn class="primary ml-4" dark @click="resetJson">
              Сбросить настройки
            </v-btn>
            <v-btn class="green ml-4" dark @click="onSubmit">
              {{ isEdit ? 'Сохранить изменения' : 'Добавить WMS' }}
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import get from 'lodash/get';
import VJsoneditor from 'v-jsoneditor/src/index';

const createDefaultForm = () => ({
  name: '',
  style: '',
  url: '',
  published: false,
});

export default {
  name: 'wms-form',
  components: {
    VJsoneditor,
  },

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    wmsData: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    form: createDefaultForm(),
    valid: true,
    rules: {
      name: [
        v => !!v || 'Название wms обязательно для заполнения',
      ],
    },
    json: null,
    advancedMode: false,
  }),

  computed: {
    publishedText() {
      return this.form.published ? 'Подложка опубликована' : 'Подложка скрыта';
    },
  },

  watch: {
    wmsData: {
      immediate: true,
      handler: 'initForm',
    },

    'form.url': function onFormUrlChange(newValue, oldValue) {
      const tiles = get(this.json, 'sources.raster.tiles', []);
      const index = tiles.findIndex((url) => url === oldValue);
      if (index !== -1) {
        this.$set(this.json.sources.raster.tiles, index, newValue);
      }
    },

    json: {
      deep: true,
      handler(value) {
        this.form.style = JSON.stringify(value);
      },
    },
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.json) {
          delete this.form.url;
        } else {
          delete this.form.style;
        }

        this.$emit('submit', this.form);
      }
    },

    initForm() {
      this.json = JSON.parse(this.wmsData.style || null);

      this.form = JSON.parse(JSON.stringify({
        ...this.form,
        ...this.wmsData,
        url: get(this.json, 'sources.raster.tiles[0]', null),
      }));
    },

    resetJson() {
      this.json = null;
    },
  },
};
</script>

<style scoped>

</style>
